import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Business } from '../models/business.model';
import { hasTag, loadTags } from '../../util/tag-utils';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditTagsComponent } from '../../shared/edit-tags/edit-tags.component';
import { TagService } from '../../shared/services/tag.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
var RentalsComponent = /** @class */ (function () {
    function RentalsComponent(_toggleService, _editRentalsCheckboxDialog, _businessManagerService, _tagService, snackBar) {
        var _this = this;
        this._toggleService = _toggleService;
        this._editRentalsCheckboxDialog = _editRentalsCheckboxDialog;
        this._businessManagerService = _businessManagerService;
        this._tagService = _tagService;
        this.snackBar = snackBar;
        this.planeAndGliderTags = [];
        this.rotorcraftTags = [];
        this.equipmentTags = [];
        this.simulatorTags = [];
        this.hasTag = hasTag;
        this.editModeSet = false;
        this.isRegionalManager = false;
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
        });
    }
    RentalsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var allTags, _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.loadAllTags();
                        return [4 /*yield*/, this._tagService.getAllTags()];
                    case 1:
                        allTags = _c.sent();
                        this.setPrivate(allTags);
                        this.privateTag = this._tagService.findTagByName(allTags, 'Rental::Private');
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isRegionalManager()];
                    case 2:
                        _b = (_c.sent());
                        if (!_b) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._businessManagerService.userOwnsBusiness(this.business.id)];
                    case 3:
                        _b = !(_c.sent());
                        _c.label = 4;
                    case 4:
                        _a.isRegionalManager = _b;
                        return [2 /*return*/];
                }
            });
        });
    };
    RentalsComponent.prototype.loadAllTags = function () {
        this.planeAndGliderTags = loadTags(this.business.tags, 'Rental::Airplane::', 'Rental::Glider', '');
        this.rotorcraftTags = loadTags(this.business.tags, 'Rental::Rotorcraft::', '', '');
        this.equipmentTags = loadTags(this.business.tags, 'Rental::Equipment::', '', '');
        this.simulatorTags = loadTags(this.business.tags, 'Rental::Simulator::', '', '');
    };
    Object.defineProperty(RentalsComponent.prototype, "hasContent", {
        get: function () {
            return this.planeAndGliderTags.length > 0 || this.rotorcraftTags.length > 0
                || this.equipmentTags.length > 0 || this.simulatorTags.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    RentalsComponent.prototype.setPrivate = function (allTags) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._tagService.findTagByName(allTags, 'Rental::Private')];
                    case 1:
                        _a.privateTag = _b.sent();
                        this.isPrivate = hasTag(this.business.tags, 'Rental::Private');
                        return [2 /*return*/];
                }
            });
        });
    };
    RentalsComponent.prototype.isChecked = function (tagId) {
        var TAGS = this.business.tags;
        for (var _i = 0, TAGS_1 = TAGS; _i < TAGS_1.length; _i++) {
            var tag = TAGS_1[_i];
            if (tag.tagId === tagId) {
                return true;
            }
        }
        return false;
    };
    RentalsComponent.prototype.checkBoxChanged = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR_MSG, TAG_ID, BUSINESS_ID, newBusiness, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ERROR_MSG = 'Unable to save change, please try back later, or call 1-800-USA-AOPA if the error persists.';
                        TAG_ID = +event.source.id;
                        BUSINESS_ID = this.business.id;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        if (!event.source.checked) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._tagService.postTag(TAG_ID, BUSINESS_ID)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this._tagService.deleteTag(TAG_ID, BUSINESS_ID)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [4 /*yield*/, this._businessManagerService.updateBusiness(this.business)];
                    case 6:
                        newBusiness = _a.sent();
                        Object.assign(this.business, newBusiness);
                        return [3 /*break*/, 8];
                    case 7:
                        e_1 = _a.sent();
                        this.snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                        throw e_1;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    RentalsComponent.prototype.openEditRentalsDialog = function (group, except, title) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            business: this.business,
            tagsGroup: group,
            except: except,
            title: title
        };
        dialogConfig.width = '95%';
        var dialogRef = this._editRentalsCheckboxDialog.open(EditTagsComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isSuccess) {
            if (isSuccess) {
                _this.loadAllTags();
            }
            else {
                _this.snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return RentalsComponent;
}());
export { RentalsComponent };
